import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
const { FiX, FiCheck, FiSettings, FiPlus, FiChevronDown } = FiIcons;
import SafeIcon from '../common/SafeIcon';
import supabase from '../supabase/supabase';

const EditTestModal = ({ isOpen, onClose, test, profile, onSuccess }) => {
  const [title, setTitle] = useState('');
  const [category, setCategory] = useState('');
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isManaging, setIsManaging] = useState(false);
  const [newCat, setNewCat] = useState('');

  useEffect(() => {
    if (test) {
      setTitle(test.title || '');
      setCategory(test.category || 'Todos');
    }
    if (profile?.id && isOpen) {
      fetchCategories();
    }
  }, [test, profile?.id, isOpen]);

  const fetchCategories = async () => {
    const { data } = await supabase.from('app_categories').select('*').eq('user_id', profile.id);
    const cats = data || [];
    if (!cats.find(c => c.name === 'Todos')) cats.unshift({ name: 'Todos' });
    setCategories(cats);
  };

  const handleAddCategory = async () => {
    if (!newCat.trim()) return;
    await supabase.from('app_categories').insert({ user_id: profile.id, name: newCat.trim() });
    setNewCat('');
    fetchCategories();
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      const { error } = await supabase
        .from('app_tests')
        .update({ title, category })
        .eq('id', test.id);
      
      if (error) throw error;
      onSuccess();
      onClose();
    } catch (err) {
      alert("Erro ao salvar: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-[150] flex items-center justify-center p-4">
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={onClose} className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm" />
        <motion.div initial={{ scale: 0.9, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} className="relative w-full max-w-md bg-white rounded-[40px] shadow-2xl p-8 overflow-hidden">
          <div className="flex justify-between items-center mb-6">
            <h3 className="text-xl font-black uppercase italic text-slate-900">Editar Teste</h3>
            <button onClick={onClose} className="p-2 rounded-xl hover:bg-slate-100"><SafeIcon icon={FiX} /></button>
          </div>

          <div className="space-y-4">
            <div>
              <label className="text-[10px] font-black uppercase text-slate-400 ml-1">Assunto / Candidato</label>
              <input 
                type="text" 
                value={title} 
                onChange={e => setTitle(e.target.value)}
                className="w-full p-4 bg-slate-50 border-0 rounded-2xl font-bold text-slate-900 focus:ring-2 focus:ring-indigo-500 outline-none"
              />
            </div>

            <div>
              <div className="flex justify-between items-center mb-1">
                <label className="text-[10px] font-black uppercase text-slate-400 ml-1">Categoria</label>
                <button onClick={() => setIsManaging(!isManaging)} className="text-[10px] font-black uppercase text-indigo-600 flex items-center gap-1">
                  <SafeIcon icon={FiSettings} /> {isManaging ? 'Concluir' : 'Gerenciar'}
                </button>
              </div>
              
              {isManaging ? (
                <div className="space-y-2 animate-in fade-in duration-300">
                  <div className="flex gap-2">
                    <input 
                      type="text" 
                      placeholder="Nova categoria..." 
                      value={newCat} 
                      onChange={e => setNewCat(e.target.value)}
                      className="flex-1 p-3 bg-slate-50 rounded-xl text-xs font-bold"
                    />
                    <button onClick={handleAddCategory} className="p-3 bg-indigo-600 text-white rounded-xl"><SafeIcon icon={FiPlus} /></button>
                  </div>
                  <div className="max-h-32 overflow-y-auto space-y-1 pr-2 no-scrollbar">
                    {categories.map(c => (
                      <div key={c.id || c.name} className="p-2 bg-slate-50 rounded-lg text-[10px] font-bold text-slate-600 flex justify-between uppercase">
                        {c.name}
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <div className="relative">
                  <select 
                    value={category} 
                    onChange={e => setCategory(e.target.value)}
                    className="w-full p-4 bg-slate-50 border-0 rounded-2xl font-bold text-slate-900 focus:ring-2 focus:ring-indigo-500 outline-none appearance-none"
                  >
                    {categories.map(c => <option key={c.id || c.name} value={c.name}>{c.name}</option>)}
                  </select>
                  <SafeIcon icon={FiChevronDown} className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none" />
                </div>
              )}
            </div>

            <button 
              onClick={handleSave}
              disabled={loading}
              className="w-full py-4 bg-indigo-600 text-white rounded-2xl font-black uppercase italic shadow-lg shadow-indigo-100 mt-4 disabled:opacity-50"
            >
              {loading ? 'Salvando...' : 'Salvar Alterações'}
            </button>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default EditTestModal;